import { getAuth, Auth } from 'firebase/auth';
import { firebaseApp } from './firebase';

let auth: Auth;
export const getFirebaseAuth = () => {
  return auth ? auth : (auth = getAuth(firebaseApp));
};
